import { CalendarHeart, Clock, MapPin } from "lucide-react";
import { Reveal } from "./Reveal";

const MAPS_URL =
  "https://www.google.com/maps/search/?api=1&query=240%20N%20Devon%20Ave%2C%20Indianapolis%2C%20IN%2046219";

const DRESS_CODE_COLORS = [
  { name: "Terracota", hex: "#A54A2F" },
  { name: "Óxido", hex: "#C46A3A" },
  { name: "Ocre Mostaza", hex: "#D4A03A" },
  { name: "Verde Oliva", hex: "#6B6F44" },
  { name: "Vino", hex: "#5B2B2B" },
];

const ITEMS = [
  { icon: CalendarHeart, label: "La Fecha", value: "Sábado, 10 de Octubre de 2026", testid: "detail-date" },
  { icon: Clock, label: "La Hora", value: "2:00 PM", testid: "detail-time" },
  { icon: MapPin, label: "El Lugar", value: "En nuestro hogar · 240 N Devon Ave, Indianapolis, IN 46219", testid: "detail-venue" },
];

export const Details = () => (
  <section id="detalles" data-testid="details-section" className="relative py-28 md:py-40 px-6 bg-sand">
    <div className="max-w-5xl mx-auto">
      <Reveal>
        <p className="font-script text-clay text-3xl md:text-4xl text-center">Los Detalles</p>
        <h2 className="font-serif text-4xl md:text-5xl tracking-tight text-center mt-3 text-ink">
          Te esperamos en casa
        </h2>
        <p className="mt-6 text-center text-stone text-sm md:text-base max-w-xl mx-auto leading-relaxed">
          Queremos celebrar este día en el lugar que más amamos: nuestro hogar. Tu presencia es el mejor regalo.
        </p>
      </Reveal>
      <div className="mt-16 grid md:grid-cols-3 gap-6">
        {ITEMS.map((item, i) => (
          <Reveal key={item.label} delay={0.12 * i} className="border border-clay/15 rounded-3xl bg-cream p-10 text-center">
            <div className="mx-auto w-14 h-14 rounded-full bg-peach/40 flex items-center justify-center text-clay">
              <item.icon size={24} strokeWidth={1.5} />
            </div>
            <p className="mt-6 text-[11px] uppercase tracking-[0.35em] text-stone">{item.label}</p>
            <p data-testid={item.testid} className="mt-3 font-serif text-xl md:text-2xl text-ink leading-snug">
              {item.value}
            </p>
          </Reveal>
        ))}
      </div>
      <Reveal delay={0.2} className="mt-16">
        <div data-testid="dress-code-section" className="border border-clay/15 rounded-3xl bg-cream p-10 md:p-12 text-center">
          <p className="font-script text-clay text-3xl md:text-4xl">Código de Vestimenta</p>
          <p className="mt-4 text-stone text-sm md:text-base max-w-xl mx-auto leading-relaxed">
            Nos encantaría que nos acompañaran vistiendo alguno de estos colores el día de nuestra boda.
          </p>
          <div className="mt-8 flex justify-center items-start gap-3 md:gap-8">
            {DRESS_CODE_COLORS.map((c) => (
              <div key={c.hex} className="flex flex-col items-center gap-3 w-14 md:w-20">
                <div
                  data-testid={`dress-code-color-${c.hex.replace("#", "")}`}
                  style={{ backgroundColor: c.hex }}
                  className="w-12 h-12 md:w-16 md:h-16 rounded-full border border-ink/5 hover:scale-110 hover:-translate-y-1 transition-transform duration-300"
                />
                <p className="text-[9px] md:text-[10px] uppercase tracking-[0.12em] text-stone text-center leading-tight">
                  {c.name}
                </p>
              </div>
            ))}
          </div>
        </div>
      </Reveal>
      <Reveal delay={0.3} className="text-center mt-12">
        <a
          data-testid="maps-link"
          href={MAPS_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block rounded-full border border-clay text-clay px-10 py-4 text-[11px] uppercase tracking-[0.3em] hover:bg-clay hover:text-cream transition-colors"
        >
          Cómo llegar
        </a>
      </Reveal>
    </div>
  </section>
);
